import {View, Text, Modal, TouchableOpacity} from 'react-native';
import React from 'react';
import Feather from 'react-native-vector-icons/Feather';
import {Colors} from '../../../../constants/Colors';

import ButtonComponent from '../../../../components/ButtonComponent/ButtonComponent';
import {styles} from './styles';
import CheckBox from '../../../../components/CheckBox/CheckBox';

interface IModalFilter {
  visible: boolean;
  onRequestClose: () => void;
  onPress: () => void;
}

const AcceptTermModal = ({visible, onRequestClose, onPress}: IModalFilter) => {
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={visible}
      onRequestClose={onRequestClose}>
      <View style={styles.containerModal}>
        <View style={styles.containerFilter}>
          <View style={styles.spaceHorizontal}>
            <TouchableOpacity onPress={onRequestClose}>
              <Feather
                name="x"
                size={32}
                color={Colors.lightGray}
                style={styles.iconX}
              />
            </TouchableOpacity>
          </View>
          <Text
            style={{
              fontSize: 22,
              lineHeight: 26,
              color: 'black',
              textAlign: 'center',
              maxWidth: 200,
              alignSelf: 'center',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 20,
            }}>
            Termo de aceite da campanha
          </Text>
          <TouchableOpacity>
            <Text
              style={{
                fontSize: 16,
                lineHeight: 20,
                color: Colors.RedPallete.red,
                fontFamily: 'TCCC-UnityHeadline Regular',
                alignSelf: 'center',
                marginTop: 20,
              }}>
              Ler termo
            </Text>
          </TouchableOpacity>
          <CheckBox
            description="Li e aceito os termos da campanha"
            alignSelf="center"
            mt={50}
          />
          <View style={styles.containerDrop}></View>
          <View style={styles.containerButton}>
            <ButtonComponent title="Não participar" outlined width="48%" />
            <ButtonComponent title="Participar" width="48%" onPress={onPress} />
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default AcceptTermModal;
